import { FC } from "react";

interface SortProps {
  active?: boolean;
  direction?: "asc" | "desc";
  activeColor?: string;
  defaultColor?: string;
}

const Sort: FC<SortProps> = ({
  active = false,
  direction = "asc",
  defaultColor = "#E0E0E0",
  activeColor = "#167E76",
}) => {
  const color = active ? activeColor : defaultColor;

  const ascPath =
    "M14 6L10 6V8L14 8L14 6ZM21 18V16L3 16V18L21 18ZM18 11L6 11V13L18 13V11Z"; // up arrow
  const descPath = "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"; // down arrow

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={direction === "asc" ? ascPath : descPath} fill={color} />
    </svg>
  );
};

export default Sort;
